import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import {
  CtaButton,
  MatchHeader,
  MatchHeaderThumbnail,
  MatchTimer,
} from "../../ReusableComponents/index";
import { useSelector, useDispatch } from "react-redux";
import {
  getPath,
  getTranslations,
  isAndroid,
  isIOS,
  isMobile,
} from "../../Common/utils";
import { gameplay, fixtureCircuitConfig } from "../../redux/actions/";
import SectionLoader from "../Loaders/SectionLoader";
import {
  currentFixture,
  getGDStatus,
  getPreviousFixtures,
} from "../../Common/utils/fixture";
import { isUserLoggedIn } from "../../Common/utils/user";
import useIPadOrientation from "../../Common/hooks/useIPadOrientation";
import {
  FANTASY_ANDROID,
  FANTASY_IOS,
  FANTASY_WEBSITE,
  INTERNAL,
  PORTRAIT,
  WEB,
  WEBVIEW,
} from "../../Common/constants";
import useDataLayer from "../../Common/hooks/useDataLayer";
import useTournamentScanario from "../../Common/hooks/useTournamentScanario";
import { useSearchParams } from "react-router-dom";
const MatchHeaderMaster = (MatchHeaderMasterConfig) => {
  const {
    matchHeaderThumbnail = false,
    matchHeaderCta = false,
    matchHeaderMoreDetails = false,
    showCTA = false,
    currentSeasonYear = null,
  } = MatchHeaderMasterConfig;
  const navigate = useNavigate();
  const mixAPIState = useSelector((state) => state.mixapi);
  const translationState = useSelector((state) => state.translation);
  const gameplayState = useSelector((state) => state.gameplay);
  const userState = useSelector((state) => state.user);
  const webview = userState?.webview;

  const { isEos, lastGamedayRaceLocked } = useTournamentScanario();
  const pushToDataLayer = useDataLayer();

  const { isIPad, screenDimensionOrientation } = useIPadOrientation();

  const isIPadPortrait = isIPad && screenDimensionOrientation === PORTRAIT;
  const disableCTAs = isEos || lastGamedayRaceLocked;

  const hasCreatedTeam = () => gameplayState?.teams?.length;

  const dispatch = useDispatch();
  const fixtureCircuitConfigState = useSelector(
    (state) => state.fixtureCircuitConfig
  );
  const fixtureCircuitConfigData = fixtureCircuitConfigState?.data;
  const fixtures = fixtureCircuitConfigData?.fixtures;

  const mixApiFeedBusters = mixAPIState?.data?.feedBuster;
  const mixApiFixturesBuster = mixApiFeedBusters?.fixtures;
  const fixturesBusterRef = useRef();
  const getPreviousRaceSession = () => {
    const pcDoneRace = getPreviousFixtures(fixtures);

    const value = pcDoneRace.filter(
      (pcDoneRace) => pcDoneRace?.SessionType === "Race"
    );
    return value?.[value?.length - 1];
  };

  const displayPreviousRaceResults = () => {
    const endTime = new Date(
      getPreviousRaceSession()?.NextMatchDeadline
    ).getTime();
    const currentTime = new Date().getTime();

    return endTime > currentTime;
  };

  const atLeastOneRaceWeekCompleted = () => {
    const teamOneUserGamedays = gameplayState?.userGameDaysV1?.[1];
    const teamOneMdDetails = teamOneUserGamedays?.mddetails;

    let isOneRaceweekCompleted = false;

    for (const gamedayId in teamOneMdDetails) {
      const value = teamOneMdDetails?.[gamedayId];

      if (value?.mds === 3) {
        isOneRaceweekCompleted = true;
        break;
      }
    }

    return isOneRaceweekCompleted;
  };

  const fetchFixtures = () => {
    dispatch(
      fixtureCircuitConfig.fetchFixtureCircuitConfig({ languageCode: "en" })
    );
  };

  // useEffect(() => {
  //   if (!fixturesBusterRef.current) {
  //     fixturesBusterRef.current = mixApiFixturesBuster;
  //     return;
  //   }
  //   if (fixturesBusterRef.current !== mixApiFixturesBuster) {
  //     fetchFixtures();
  //     fixturesBusterRef.current = mixApiFixturesBuster;
  //   }
  // }, [mixApiFixturesBuster]);

  if (!Object.keys(fixtures).length) {
    fetchFixtures();
  }

  const toggleCircuitPopup = () => {
    dispatch(gameplay.toggleCircuitPopup());
  };

  const handleClick = () => {
    const dataLayerObject = {
      pageName: "Home",
      actionType: "CTA Click",
      pathType: INTERNAL,
      platform: isAndroid()
        ? FANTASY_ANDROID
        : isIOS()
        ? FANTASY_IOS
        : FANTASY_WEBSITE,
      componentType: webview ? WEBVIEW : WEB,
    };
    if (hasCreatedTeam()) {
      if (displayPreviousRaceResults() && atLeastOneRaceWeekCompleted()) {
        navigate({
          pathname: getPath(translationState, "myTeam"),
          search: "?tab=completed",
        });
      } else {
        pushToDataLayer("manageYourTeam", {
          ...dataLayerObject,
          path: "/my-team",
        });
        navigate(getPath(translationState, "myTeam"));
      }
    } else {
      pushToDataLayer("pickYourTeam", {
        ...dataLayerObject,
        path: "/create-team",
      });
      navigate(getPath(translationState, "createTeam"));
    }
  };

  const mainCTAText = () => {
    if (hasCreatedTeam()) {
      if (displayPreviousRaceResults() && atLeastOneRaceWeekCompleted()) {
        return getTranslations(
          "landing_page_raceday_cta_3",
          "View Previous Results"
        );
      } else {
        return getTranslations(
          "landing_page_raceday_cta_2",
          "Manage Your Team"
        );
      }
    } else {
      return getTranslations("landing_page_raceday_cta", "Pick Your Team");
    }
  };

  const canShowMainCTA = () => {
    if (isUserLoggedIn(userState)) {
      return true;
    } else {
      return !!currentFixture(fixtures)?.IsActiveForNewUser;
    }
  };

  return (
    <>
      <div className="si-main__row">
        <div className="si-cmo__header">
          {fixtureCircuitConfigState?.loading ? <SectionLoader /> : ""}
          <div className="si-matchHeader__wrap">
            {!isIPadPortrait && matchHeaderThumbnail && (
              <MatchHeaderThumbnail />
            )}

            <div className="si-matchHeader__wrap-lft">
              <MatchHeader
                tagName="h1"
                fixture={currentFixture(fixtures)}
                MatchHeaderConfig={{
                  MatchHeaderExtra: true,
                  MatchStatusWrap:
                    getGDStatus(currentFixture(fixtures)?.GDStatus) === "LIVE",
                  showCTA: showCTA,
                  ShowFixtureDate: true,
                  ShowRaceweekFixtureLHS: false,
                  showFixtureData: true,
                }}
              />
              {matchHeaderMoreDetails && !isMobile() && (
                <div
                  className="si-matchHeader__cta"
                  role="button"
                  aria-label={getTranslations(
                    "landing_page_raceday_more_desc",
                    "click on more details button to know more details about circuits"
                  )}
                >
                  <CtaButton
                    variant={"link"}
                    icon=""
                    onClick={toggleCircuitPopup}
                  >
                    {getTranslations(
                      "landing_page_raceday_more",
                      "More details"
                    )}
                  </CtaButton>
                </div>
              )}
            </div>
            {getGDStatus(currentFixture(fixtures)?.GDStatus) !== "LIVE" ? (
              <div className="si-matchHeader__wrap-rgt">
                <MatchTimer
                  extraCls={"eot"}
                  fixture={currentFixture(fixtures)}
                />

                {matchHeaderCta && canShowMainCTA() && (
                  <div className="si-matchHeader__cta" role="button">
                    <CtaButton
                      fullWidth={true}
                      variant={"accent"}
                      icon="f1i-chevron-right"
                      onClick={() => handleClick()}
                      disabled={disableCTAs}
                    >
                      {mainCTAText()}
                    </CtaButton>
                  </div>
                )}
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export { MatchHeaderMaster };
